const API_BASE = globalThis.__APP_API_BASE__ ||
    import.meta.env.VITE_API_BASE ||
    'http://127.0.0.1:8787';
async function request(path, init) {
    const response = await fetch(`${API_BASE}${path}`, {
        headers: {
            'Content-Type': 'application/json'
        },
        ...init
    });
    if (!response.ok) {
        const message = await response.text();
        throw new Error(message || 'Có lỗi xảy ra từ máy chủ.');
    }
    const text = await response.text();
    return text ? JSON.parse(text) : {};
}
export const api = {
    getHealth: () => request('/health'),
    getDashboard: () => request('/dashboard'),
    getAnalysis: () => request('/analysis'),
    list: (resource) => request(`/${resource}`),
    create: (resource, payload) => request(`/${resource}`, {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    update: (resource, id, payload) => request(`/${resource}/${id}`, {
        method: 'PUT',
        body: JSON.stringify(payload)
    }),
    remove: (resource, id) => request(`/${resource}/${id}`, {
        method: 'DELETE'
    }),
    aiIdeas: (payload) => request('/ai/ideas', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    aiScript: (payload) => request('/ai/scripts', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    aiCaptions: (payload) => request('/ai/captions', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    aiHashtags: (payload) => request('/ai/hashtags', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    aiPrompt: (payload) => request('/ai/prompts', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    aiChat: (payload) => request('/ai/chat', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    exportData: () => request('/export'),
    importData: (payload) => request('/import', {
        method: 'POST',
        body: JSON.stringify(payload)
    }),
    resetSeed: () => request('/reset', {
        method: 'POST'
    })
};
